__turbopack_context__.v({
  "card": "WavelengthsSection-module__Tg69fG__card",
  "cardBody": "WavelengthsSection-module__Tg69fG__cardBody",
  "cardContent": "WavelengthsSection-module__Tg69fG__cardContent",
  "cardEyebrow": "WavelengthsSection-module__Tg69fG__cardEyebrow",
  "cardGrid": "WavelengthsSection-module__Tg69fG__cardGrid",
  "cardImage": "WavelengthsSection-module__Tg69fG__cardImage",
  "cardWavelength": "WavelengthsSection-module__Tg69fG__cardWavelength",
  "dashedDivider": "WavelengthsSection-module__Tg69fG__dashedDivider",
  "description": "WavelengthsSection-module__Tg69fG__description",
  "header": "WavelengthsSection-module__Tg69fG__header",
  "heading": "WavelengthsSection-module__Tg69fG__heading",
  "inner": "WavelengthsSection-module__Tg69fG__inner",
  "mapBackgroundImage": "WavelengthsSection-module__Tg69fG__mapBackgroundImage",
  "mapFade": "WavelengthsSection-module__Tg69fG__mapFade",
  "marker": "WavelengthsSection-module__Tg69fG__marker",
  "mobileImageDim": "WavelengthsSection-module__Tg69fG__mobileImageDim",
  "penetrationMap": "WavelengthsSection-module__Tg69fG__penetrationMap",
  "section": "WavelengthsSection-module__Tg69fG__section",
  "tissueLayerLabel": "WavelengthsSection-module__Tg69fG__tissueLayerLabel",
  "wavelengthAnnotation": "WavelengthsSection-module__Tg69fG__wavelengthAnnotation",
});
